import { Component, computed, input } from '@angular/core';

export type CardVariant = 'solid' | 'dashed' | 'elevated';

@Component({
  selector: 'lib-card',
  host: {
    '[class]': 'hostClasses()',
    'style': 'display: block',
  },
  template: `
    <div class="msa-card" [class]="'msa-card msa-card--' + variant()">
      <ng-content />
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .msa-card {
      border-radius: 12px;
      padding: 12px 16px;
      font-size: 12px;
      color: #4b5563;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      flex-wrap: wrap;
    }

    /* Solid variant — default */
    .msa-card--solid {
      background: #fff;
      border: 1px solid #e5e7eb;
    }

    /* Dashed variant — info/prompt card */
    .msa-card--dashed {
      background: #f9fafb;
      border: 1px dashed #d1d5db;
    }

    /* Elevated variant — no border, shadow */
    .msa-card--elevated {
      background: #fff;
      border: 1px solid #e5e7eb;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
    }
  `]
})
export class CardComponent {
  readonly variant = input<CardVariant>('solid');

  readonly hostClasses = computed(() => ({
    'msa-card-host': true,
    [`msa-card-host--${this.variant()}`]: true,
  }));
}
